<template>
    <div class="print-offer max-height">
      <button @click="fetchOffer"
              :class="{'disabledPrint': disabledPrint}"
              :disabled="disabledPrint">{{'print' | translate}}</button>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import OfferService from '../services/offer';
import Gateway from '../services/gateway';

export default {
  name: 'PrintOffer',
  data() {
    return {
      disabledPrint: false,
    };
  },
  computed: {
    ...mapGetters([
      'gameId',
    ]),
  },
  methods: {
    /**
    * Fetch game offer for print
    */
    fetchOffer() {
      this.disabledPrint = true;
      const data = {
        gameId: this.gameId,
      };
      OfferService.getOfferForPrint(data).then((response) => {
        this.printOffer(response.data.downloadUrl);
      });
    },
    printOffer(offer) {
      const actionData = {
        message: 'Peripherals.PrintA4',
        data: {
          documentUrl: offer,
        },
      };
      Gateway.sendMessage(actionData.message, actionData.data);
      setTimeout(() => {
        this.disabledPrint = false;
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
  .print-offer {
    position: relative;
  }
</style>
